<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <BaseModal v-model="commentsModal" size="lg">
            <MeetingComments :meetingId="selected[0]?.id" />
        </BaseModal>

        <BaseModal v-model="documentsModal" size="lg">
            <MeetingDocumentation :meetingId="selected[0]?.id" />
        </BaseModal>        

        <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected" show-empty selected-variant="light">
            <template #empty>
                <b-card v-if="searchQuery !== ''" class="text-center my-2 fs-5">
                    No hay reuniones que coincidan con el criterio de búsqueda: <code>{{ searchQuery }}</code>
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    <div v-if="dateQuery">
                        No hay reuniones para el periodo seleccionado
                    </div>
                    <div v-else>
                        Aún no se ha agregado ninguna reunión
                    </div>

                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

            <template #cell(options)="{ rowSelected, selectRow }">
                <template v-if="rowSelected">
                    <div class="d-flex align-items-center">
                        <div class="btn-group">
                            <button @click="openModalDocuments" type="button" class="btn btn-outline-primary btn-sm"
                                v-b-tooltip.hover="'Evidencias'">
                                <b-icon icon="file-earmark-medical-fill"></b-icon>
                            </button>

                            <button @click="openModalComments" type="button" class="btn btn-outline-secondary btn-sm"
                                v-b-tooltip.hover="'Comentarios'">
                                <b-icon icon="chat-left-text" font-scale="1"></b-icon>
                            </button>

                        </div>
                    </div>

                </template>
                <template v-else>
                    <button @click="selectRow" type="button" class="btn btn-light btn-sm">
                        <b-icon icon="three-dots" class="icone-not-select"></b-icon>
                    </button>
                </template>
            </template>

            <!--boton de detalles -->
            <template #cell(detalle)="row">
                <ToggleDetailsButton @click="row.toggleDetails" :showing="row.detailsShowing" />
            </template>

            <!--cuerpo de detalle-->
            <template #row-details="row">
                <small>
                    <b-card>
                        <b>Detalles</b>:
                        {{ row.item.description }}
                        <hr>
                        <b>Duración estimada</b>:
                        {{ getDuration(row.item.dateStart, row.item.dateEnd) }}
                        <div v-if="!isVirtual(row)">
                            <b>Lugar de la reunión</b>:
                            {{ row.item.address }}
                        </div>
                        <div v-if="row.item.assistants.length > 0">
                            <hr>
                            <div class="d-flex align-items-center">
                                <b>Invitados</b>
                                <b-table-lite small :items="row.item.assistants" :fields="assistantFields"
                                    class="mb-0 ms-3" />
                            </div>
                        </div>
                    </b-card>
                </small>
            </template>
        </b-table>
    </div>
</template>
<script>
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { formatDateTime } from '@/plugins/complianceScripts/index.js'
import { mapActions } from 'vuex'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import BaseModal from '@/components/shared/Base-modal.vue'
import ToggleDetailsButton from '@/components/shared/Toggle-details-button.vue';
import MeetingComments from './MeetingTable/Meeting-comments.vue'
import MeetingDocumentation from './MeetingTable/Meeting-documentation.vue'

export default {
    name: 'MeetingTable',

    components: {
        AlertDismiss,
        ToggleDetailsButton,
        BaseModal,
        MeetingComments,
        MeetingDocumentation
    },

    data() {
        return {
            commentsModal: false,
            documentsModal: false,

            isBusy: false,
            items: [],
            selected: [],

            //datos de filtro aqui
            searchQuery: '',
            dateQuery: null,
            roleQuery: null,

            fields: [
                { key: 'summary', label: 'Título' },
                { key: 'organizer', label: 'Organizador' },
                {
                    key: 'creationDate',
                    label: 'Fecha creación',
                    formatter: formatDateTime
                },

                {
                    key: 'dateStart',
                    label: 'Fecha inicio reunión',
                    formatter: formatDateTime
                },
                { key: 'detalle', label: 'Detalle' },
                { key: 'options', label: 'Opciones' },
            ],

            assistantFields: [
                {
                    key: 'name',
                    label: 'Nombre',
                    formatter: (value) => {
                        return value === 'no definido' ? 'Invitado externo' : value;
                    },
                    thClass: 'col-3'
                },
                {
                    key: 'lastName',
                    label: 'Apellido',
                    formatter: (value) => {
                        return value === 'no definido' ? null : value;
                    },
                    thClass: 'col-3'

                },
                { key: 'mail', label: 'Email' },
            ]
        }
    },

    async mounted() {
        this.$eventBus.$on(EventNames.PaginationFilterMeet, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.meetingsForPage(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterMeetAfterSearch, (query) => {
            this.processingTable();

            this.searchQuery = query

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.CreateMeeting, async (query) => {
            this.processingTable();

            let page = query.page - 1; //se resta 1 por que el indice comienza en 0
            let pageSize = query.pageSize;

            await this.meetingsForPage(page, pageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.ClearMeetingsFilter, async () => {
            this.processingTable();
            this.dateQuery = null;
            this.roleQuery = null;

            await this.meetingsForPage(0, InitPageSize.MeetingPageSize);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterMeetingsByDate, async (query) => {
            this.processingTable();

            this.dateQuery = query;

            await this.allMeetingsByDate(query);

            this.processingTable();
        });

        this.$eventBus.$on(EventNames.FilterMeetingsByRole, async (query) => {
            this.processingTable();
            this.roleQuery = query;

            await this.allMeetingsByRole(query);

            this.processingTable();
        });
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            if (this.searchQuery) {
                filtered = this.filterForSearch(filtered, this.searchQuery)
            }

            // Filtrar aqui
            return filtered;
        }
    },

    methods: {
        ...mapActions(["allMeetingsForPage", "getAllMeetingsByDate", "getAllMeetingsByRole"]),

        onRowSelected(items) {
            this.selected = items;
        },

        async MeetingsCount(query) {
            let result = await this.getMeetingsCount(query);
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }
            this.count = result.data;
        },

        async allMeetingsByDate(query) {
            let result = await this.getAllMeetingsByDate({ initDate: query.startDate, finalDate: query.endDate });
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }
            this.items = result.data;
        },

        async allMeetingsByRole(query) {
            let result = await this.getAllMeetingsByRole({ organizerRoles: query });
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }
            this.items = result.data;
        },

        async meetingsForPage(page, pageSize) {
            let result = await this.allMeetingsForPage({ page: page, pageSize: pageSize });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.items = result.data;
        },

        processingTable() {
            this.isBusy = !this.isBusy
        },

        filterForSearch(meets, searchQuery) {
            const normalizedQuery = searchQuery.toLowerCase().trim();

            return meets.filter(item =>
                Object.values(item).some(value =>
                    value.toString().toLowerCase().includes(normalizedQuery)
                )
            );
        },

        getDuration(dateStart, dateEnd) {
            let totalMinutes = Math.floor((new Date(dateEnd) - new Date(dateStart)) / (1000 * 60));
            let hours = Math.floor(totalMinutes / 60);
            let minutes = totalMinutes % 60;

            let hoursString = hours === 1 ? 'hora' : 'horas';
            let minutesString = minutes === 1 ? 'minuto' : 'minutos';

            if (hours === 0) {
                return `${minutes} ${minutesString}`;
            } else if (minutes === 0) {
                return `${hours} ${hoursString}`;
            }

            return `${hours} ${hoursString} y ${minutes} ${minutesString}`;
        },

        isVirtual(row) {
            return row.item.place === 'virtualPlace'
        },

        openModalDocuments() {
            this.documentsModal = true;
        },

        openModalComments() {
            this.commentsModal = true;
        }
    },

}
</script>
<style scoped>
hr {
    margin: 0.2rem 0;
    color: grey
}
</style>
